import React, { useState } from 'react';
import { 
  Search, Filter, Plus, FileText, Calendar, 
  CheckCircle, Clock, X, Send
} from 'lucide-react';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import { quotes } from '../data/mockData';

const getStatusConfig = (status) => {
  const configs = {
    sent: { label: 'Sent', color: 'bg-blue-100 text-emerald-700', Icon: Send },
    accepted: { label: 'Accepted', color: 'bg-green-100 text-green-700', Icon: CheckCircle },
    pending: { label: 'Pending', color: 'bg-amber-100 text-amber-700', Icon: Clock },
    declined: { label: 'Declined', color: 'bg-red-100 text-red-700', Icon: X },
  };
  return configs[status] || configs.pending;
};

const QuoteCard = ({ quote }) => {
  const statusConfig = getStatusConfig(quote.status);
  const StatusIcon = statusConfig.Icon;
  
  return (
    <div className="bg-white border-b border-gray-100 p-4 hover:bg-gray-50 transition-colors cursor-pointer">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            <h3 className="font-semibold text-gray-900">{quote.customerName}</h3>
            <Badge className={statusConfig.color}>
              <StatusIcon size={12} className="mr-1" />
              {statusConfig.label}
            </Badge>
          </div>
          
          <p className="text-sm text-gray-600 mb-2">{quote.description}</p>
          
          <div className="flex items-center gap-4 text-sm text-gray-500">
            <div className="flex items-center gap-1">
              <Calendar size={14} />
              <span>Valid until {quote.validUntil}</span>
            </div>
          </div>
        </div>
        
        <div className="text-right">
          <p className="text-xl font-semibold text-gray-900">£{quote.amount.toFixed(2)}</p>
          <p className="text-xs text-gray-400">{quote.id}</p>
        </div>
      </div>
    </div>
  );
};

const Quotes = () => {
  const [searchQuery, setSearchQuery] = useState('');
  
  const filteredQuotes = quotes.filter(function(quote) {
    return quote.customerName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      quote.description.toLowerCase().includes(searchQuery.toLowerCase());
  });

  return (
    <div className="h-full flex flex-col">
      <div className="p-4 bg-white border-b border-gray-200">
        <div className="flex gap-3">
          <div className="relative flex-1">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} />
            <Input
              placeholder="Search quotes..."
              value={searchQuery}
              onChange={function(e) { setSearchQuery(e.target.value); }}
              className="pl-10"
            />
          </div>
          <Button variant="outline" size="icon">
            <Filter size={18} />
          </Button>
        </div>
      </div>
      
      <div className="px-4 py-2 bg-gray-50 text-sm text-gray-600">
        {filteredQuotes.length} quotes
      </div>
      
      <div className="flex-1 overflow-y-auto">
        {filteredQuotes.map(function(quote) {
          return <QuoteCard key={quote.id} quote={quote} />;
        })}
      </div>
      
      <button className="fixed bottom-20 right-6 w-14 h-14 bg-pink-500 rounded-full shadow-lg flex items-center justify-center text-white hover:bg-pink-600 transition-colors">
        <Plus size={24} />
      </button>
    </div>
  );
};

export default Quotes;
